
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ReportTypes } from '../../../interfaces/Reports';
import { JobConfigs } from '../constant/JobConfig';

const SchedulerTable = lazy(() => import("../components/SchedulerTable"));

const RoutesFromConfig = ()=>{
  const data = []
  for (const [key,value] of Object.entries(JobConfigs)){
    if(value.enabled){
      data.push({
        path : `${key}`,
        element : <SchedulerTable reportType = {key as ReportTypes} />
      })
    }
  }
  return data
}

const SchedulerListingRoute: RouteObject = {
  path: "/reports/automation/",
  children:RoutesFromConfig()
}

export default SchedulerListingRoute;